module.exports = __webpack_public_path__ + "img/index.da62a27a.svg";